import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  padding: 16px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
`;

export const Form = styled.form`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const TextAreaWrapper = styled.div`
  display: flex;
  align-items: center;

  padding: 12px;
  width: 100%;

  border: 1px solid ${(props) => props.theme.colors?.greys?.light};
  border-radius: 16px;
`;

export const TextArea = styled.textarea`
  display: flex;
  box-sizing: border-box;

  resize: none;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: none;
  padding: 8px 12px;
  min-height: 44px;
  max-height: 200px;

  &:focus {
    outline: none;
    border: none;
  }
`;
